(function () {
  if (window.__multicollectionTabsReady) return;
  window.__multicollectionTabsReady = true;

  function initTabs(root) {
    if (!root || root.dataset.mcplTabsInitialized === 'true') return;
    root.dataset.mcplTabsInitialized = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mcpl-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mcpl-panel]'));
    if (!tabs.length || !panels.length) return;

    function getTabIndex(tab) {
      return String(tab && tab.dataset ? tab.dataset.mcplTab : '');
    }

    function activate(index) {
      var activeIndex = String(index || '');

      tabs.forEach(function (tab) {
        var isActive = getTabIndex(tab) === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var isActive = String(panel.dataset.mcplPanel || '') === activeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    function keepRootPosition(rootTopBefore) {
      function adjust() {
        var rootTopAfter = root.getBoundingClientRect().top;
        var delta = rootTopAfter - rootTopBefore;

        if (Math.abs(delta) > 1) {
          window.scrollBy(0, delta);
        }
      }

      adjust();
      requestAnimationFrame(adjust);
      requestAnimationFrame(function () {
        requestAnimationFrame(adjust);
      });
      setTimeout(adjust, 0);
      setTimeout(adjust, 50);
      setTimeout(adjust, 150);
      setTimeout(adjust, 350);
    }

    function switchTab(tab) {
      if (!tab) return;

      var index = getTabIndex(tab);
      if (!index) return;

      var rootTopBefore = root.getBoundingClientRect().top;
      var prevHtmlScrollBehavior = document.documentElement.style.scrollBehavior;
      var prevBodyScrollBehavior = document.body.style.scrollBehavior;

      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';

      activate(index);

      if (typeof tab.blur === 'function') tab.blur();
      keepRootPosition(rootTopBefore);

      setTimeout(function () {
        document.documentElement.style.scrollBehavior = prevHtmlScrollBehavior;
        document.body.style.scrollBehavior = prevBodyScrollBehavior;
      }, 400);
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-mcpl-tab]');
      if (!tab || !root.contains(tab)) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      switchTab(tab);
    }, true);

    tabs.forEach(function (tab) {
      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].includes(event.key)) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        var currentIndex = tabs.indexOf(tab);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = currentIndex + 1 >= tabs.length ? 0 : currentIndex + 1;
        if (event.key === 'ArrowLeft') nextIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        var nextTab = event.key === 'Enter' || event.key === ' ' ? tab : tabs[nextIndex];
        switchTab(nextTab);

        if (nextTab && typeof nextTab.focus === 'function') {
          try {
            nextTab.focus({ preventScroll: true });
          } catch (error) {
            nextTab.focus();
          }
        }
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-mcpl-root]')) {
      initTabs(context);
    }
    context.querySelectorAll('[data-mcpl-root]').forEach(initTabs);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
